export default __webpack_public_path__ + "static/media/pressure-icon.10932cff.png";